module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/logos/product/slack-4ac15fc81b53115208c5d0434ae50109.svg";